import { log } from "./log"

export type ScriptAttribute = [string, string]

/**
 * Install an external piece of Javascript.
 * This creates and appends a <script> element to <body>. Loading is async by
 * default, but can be customized via the attributes param.
 *
 * @param uniqueName a unique name for the script being installed
 * @param src the script's source
 * @param attributes an array attributes for the script, provided as tuples
 * @returns boolean; true if the script was installed, false otherwise
 */
export const installScript = (
  uniqueName: string,
  src: string,
  attributes: ScriptAttribute[] = []
): boolean => {
  log([`[gacf > utils] installing a script named ${uniqueName}`])

  // only install script if needed
  if (document.querySelector(`script[name="${uniqueName}"]`)) {
    log([
      `[gacf > utils] a script named ${uniqueName} is already installed, lol`,
    ])
    return
  }

  const script = document.createElement(`script`)

  const _attributes = [
    [`async`, `async`],
    ...attributes,
    [`name`, uniqueName],
    [`src`, src],
  ]

  _attributes.forEach(([attrName, attrValue]) => {
    script.setAttribute(attrName, attrValue)
  })

  document.body.append(script)

  return !!document.querySelector(`script[name="${uniqueName}"]`)
}
